export default {
  namespaced: true,

  state: {
    modal: {
      show: false,
      jobShow: false,
      jobListShow: false,
      hakenShow: false,
      companyShow: false,
      mapShow: false,
      aggregtionJob: false,
    },
  },
  getters: {
    showGuide: state => state.modal.show,
    showJobGuide: state => state.modal.jobShow,
    showJobListGuide: state => state.modal.jobListShow,
    showHakenGuide: state => state.modal.hakenShow,
    showCompanyGuide: state => state.modal.companyShow,
    showMapGuide: state => state.modal.mapShow,
    showAggregtionJobGuide: state => state.modal.aggregtionJob,
  },
  mutations: {
    hideModal: state => state.modal.show = false,
    showModal: state => state.modal.show = true,
    hideJobModal: state => state.modal.jobShow = false,
    showJobModal: state => state.modal.jobShow = true,
    hideJobListModal: state => state.modal.jobListShow = false,
    showJobListModal: state => state.modal.jobListShow = true,
    hideHakenModal: state => state.modal.hakenShow = false,
    showHakenModal: state => state.modal.hakenShow = true,
    hideCompanyModal: state => state.modal.companyShow = false,
    showCompanyModal: state => state.modal.companyShow = true,
    hideMapModal: state => state.modal.mapShow = false,
    showMapModal: state => state.modal.mapShow = true,
    hideAggregtionJobModal: state => state.modal.aggregtionJob = false,
    showAggregtionJobModal: state => state.modal.aggregtionJob = true,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/guide.js